import Vue from 'vue'

Vue.filter('formatDistance', function (value) {
  if (value) {
    return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0 }).format(Math.round(value)) + 'km'
  }
})
